<template>
  <div class="scheduled-export-setting-list">
    <!-- 設定リスト -->
    <div class="settings-list">
      <ScheduledExportSettingCard
        v-for="setting in settings"
        :key="setting.id"
        :setting="setting"
        @click="$emit('select-setting', setting)"
      />
    </div>

    <div
      class="create-button-wrapper"
    >
      <BBtn
        type="primary"
        :outline="settings.length > 0"
        @click="$emit('create-new')"
      >
        {{ $t('general.createNew') }}
      </BBtn>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ScheduledLeadExportSetting } from '@/api/openapi';
import ScheduledExportSettingCard from './ScheduledExportSettingCard.vue';

type TProps = {
  settings: ScheduledLeadExportSetting[];
};

defineProps<TProps>();
defineEmits<{
  'create-new': [];
  'select-setting': [setting: ScheduledLeadExportSetting];
}>();
</script>

<style lang="scss" scoped>
.scheduled-export-setting-list {
  padding: 20px;
  min-height: 300px;
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  min-height: 200px;

  .empty-message {
    color: $textcolor-light;
    font-size: 14px;
  }
}

.settings-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 20px;
}

.create-button-wrapper {
  display: flex;
  justify-content: center;
  padding-top: 16px;
  border-top: 1px solid $bdcolor-base;
}
</style>
